import RequestResetPasswordForm from './RequestResetPasswordForm';

export default RequestResetPasswordForm;
